// ported from https://github.com/dustin/go-humanize

export function formatSizeBinary(bytes: number) {
  return formatDigitalSize(bytes, false, false);
}

export function formatSizeMetric(bytes: number) {
  return formatDigitalSize(bytes, false, true);
}

function formatDigitalSize(
  sizeInBytes: number,
  useBits: boolean,
  useMetric: boolean,
) {
  const base = BASES.getBase(useMetric);
  const actualSize = useBits ? sizeInBytes * 8 : sizeInBytes;

  if (actualSize < 10) {
    const unit = UNITS.getUnit(useBits, useMetric, 0);
    return `${actualSize} ${unit}`;
  }

  const e = Math.floor(Math.log(actualSize) / base.log);
  const unit = UNITS.getUnit(useBits, useMetric, Math.trunc(e));
  const val = Math.floor((actualSize / base.value ** e) * 10 + 0.5) / 10;
  if (val < 10) {
    return `${val.toFixed(1)} ${unit}`;
  }

  return `${val.toFixed(0)} ${unit}`;
}

const UNITS = {
  bitsBinary: ['b', 'Kibit', 'Mibit', 'Gibit', 'Tibit', 'Pibit', 'Eibit'],
  bitsMetric: ['b', 'Kbit', 'Mbit', 'Gbit', 'Tbit', 'Pbit', 'Ebit'],
  bytesBinary: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB'],
  bytesMetric: ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB'],

  getUnit(useBits: boolean, useMetric: boolean, level: number) {
    let units;
    if (useBits) {
      units = useMetric ? UNITS.bitsMetric : UNITS.bitsBinary;
    } else {
      units = useMetric ? UNITS.bytesMetric : UNITS.bytesBinary;
    }

    return units[level];
  },
};

const BASES = {
  binary: {
    value: 1024,
    log: Math.log(1024),
  },
  metric: {
    value: 1000,
    log: Math.log(1000),
  },

  getBase(useMetric: boolean) {
    return useMetric ? BASES.metric : BASES.binary;
  },
};
